module.exports = __webpack_public_path__ + "img/message-add.b9fe60bb.svg";